export enum ContextMenuActions {
  COPY_COORDINATES = "COPY_COORDINATES",
  POPUP_PLOT = "POPUP_PLOT",
  POINT_FORECAST_PLOT = "POINT_FORECAST_PLOT",
  TEPHIGRAM = "TEPHIGRAM",
  CROSS_SECTION = "CROSS_SECTION",
}
